var exports = {
  "p6": "PinnedByContainer__PXpuCR",
  "Tm": "PinnedByIcon__vKpwiY",
  "C3": "PinnedByLink__M-97VL",
};

module.exports = exports;
